"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicalOperatorEnum = void 0;
var LogicalOperatorEnum;
(function (LogicalOperatorEnum) {
    LogicalOperatorEnum["AND"] = "AND";
    LogicalOperatorEnum["OR"] = "OR";
})(LogicalOperatorEnum || (exports.LogicalOperatorEnum = LogicalOperatorEnum = {}));
